<app-modal-mensagem
  *ngIf="sucesso"
  tipo="sucesso"
  titulo="Sucesso!"
  mensagem="Obra descartada com sucesso!"
  textoConfirmar="Continuar"
  (confirmar)="continuar()"
></app-modal-mensagem>

<div class="modal-panel-tarefa" *ngIf="!sucesso">
  <div class="modal-header">
    <div class="modal-header-left">
      <div class="modal-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="3 6 5 6 21 6" />
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
          <line x1="10" y1="11" x2="10" y2="17" />
          <line x1="14" y1="11" x2="14" y2="17" />
        </svg>
      </div>
      <div>
        <h2 class="modal-title">Obra descartada</h2>
        <p class="modal-subtitle">Informe o responsável e o relato</p>
      </div>
    </div>
    <button class="btn-close" type="button" (click)="close.emit()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label class="form-label" for="taskDescription">Descreva o relato sobre o descarte</label>
      <textarea
        id="taskDescription"
        class="form-textarea"
        [(ngModel)]="taskDescription"
        placeholder="Descreva o relato sobre o descarte..."
        rows="4"
      ></textarea>
    </div>

    <div class="form-group">
      <label class="form-label" for="responsavel">
        Responsável
        <span class="required">*</span>
      </label>
      <app-filtro-responsavel
        [responsaveis]="responsavel"
        [value]="responsavelSelecionado"
        (valueChange)="responsavelSelecionado = $event; campoObrigatorioErro = false"
        placeholder="Selecione o responsável"
        placeholderBusca="Buscar responsável"
      ></app-filtro-responsavel>
      <span class="error-msg" *ngIf="campoObrigatorioErro && !responsavelSelecionado">
        Campo obrigatório!
      </span>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn-secondary" type="button" (click)="clear()">
      Limpar dados
    </button>
    <button
      class="btn-primary"
      type="button"
      (click)="atualizarObraDescartada()"
      [disabled]="carregando"
    >
      Obra descartada
    </button>
  </div>
</div>
